import {
  API_TIMEOUT_ERROR,
  FAIL_PROCESSING_REQUEST,
} from '../../../SharedModules/Errors/constantMessageData';

export const getAcctRecvAllMfgApiErrorMessage = (error) => {
  const status = error?.response?.status;
  if (status === 504) {
    return API_TIMEOUT_ERROR;
  }
  if (status === 500) {
    return FAIL_PROCESSING_REQUEST;
  }
  return null;
};
